import React, { useContext } from 'react'
import { AuthContext, AuthState, isSupplierOwner } from 'components/common/auth/AuthContext'
import { GetMoreReviewsButton } from 'components/common/button/GetMoreReviewsButton'

interface ReviewVisibilityCalloutProps {
  proSupplier: boolean
  slug: string
}

export const ReviewVisibilityCallout: React.FC<ReviewVisibilityCalloutProps> = ({ proSupplier, slug }) => {
  const context: AuthState = useContext(AuthContext)

  const tooltipContent: string = `
    <div>
      <b>Where are the reviews?</b>
    </div>
    <br />
    <div>
      An individual review appears on your view of your supplier profile when the author explicitly chooses to make 
      their review visible to you. This option creates a space where buyers can feel comfortable sharing their honest experiences
      with each other, and consider this as a channel to share praise and actionable feedback with you. For more on why 
      we do this, check out <a class='tooltip-link' href='/resources/the-procurated-promise'>The Procurated Promise</a>.
    </div>
  `

  return (
    <>
      <div className='review-visibility-callout-container'>
        <span
          className='pro-tooltip-link body-tooltip label-tooltip'
          tabIndex={2}
          data-tooltip='true'
          data-allow-html='true'
          data-position='right'
          data-alignment='center'
          data-disable-hover='true'
          title={tooltipContent}
        >
          Where are the reviews? <i className='far fa-question-circle' />
        </span>
        {isSupplierOwner(context) && <GetMoreReviewsButton slug={slug} />}
      </div>
    </>
  )
}

ReviewVisibilityCallout.defaultProps = {
  proSupplier: false
}
